// @import types
import {IMyCourse, IMyCourseTab} from 'app_types/campus/academic/myCoursesTypes'
// @end

// @export const
export const COURSE_SELECTED_CHANGE = 'COURSE_SELECTED_CHANGE'
export const COURSE_TAB_CHANGE = 'COURSE_TAB_CHANGE'
// @end

// @declare interfaces
export interface IStateCourses {
  courseSelected: IMyCourse | null
  courseTab: IMyCourseTab | null
}
// @end

// @declare actions
interface ICourseSelectedChangeAction {
  type: typeof COURSE_SELECTED_CHANGE
  payload: IMyCourse | null
}
interface ICourseSelectedTabChangeAction {
  type: typeof COURSE_TAB_CHANGE
  payload: IMyCourseTab | null
}
// @end

// @export interfaces
export type ICoursesActionTypes = ICourseSelectedChangeAction | ICourseSelectedTabChangeAction
// @end
